import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useNavigate } from 'react-router-dom';

import { createAppUrl } from '../createAppUrl';

import { AppNavigateFunction } from './useAppNavigate.types';

/**
 * A hook that lets you work with the navigate API in association with app
 * paths, which facilitates complete type-safety.
 */
export const useAppNavigate = (): AppNavigateFunction => {
  const navigate = useNavigate();

  const typedNavigate = useCallback<AppNavigateFunction>(
    (options, navigateOptions) => {
      navigate(createAppUrl(options), navigateOptions);
    },
    [navigate],
  );

  return typedNavigate;
};
